import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./components/auth/Login";
import Signup from "./components/auth/Signup";
import Layout from "./components/sidebar/Layout";
import OnboardingSteps from "./components/auth/OnboardingSteps";
import ForgotPassword from "./components/auth/ForgotPassword";
import PasswordResetSuccess from "./components/auth/PasswordResetSuccess";
import NewPassword from "./components/auth/NewPassword";
import EmailVerification from "./components/auth/EmailVerification";
import WorkspaceReady from "./components/auth/WorkspaceReady";
import Dashboard from "./components/dashboard/Dashboard";
import AuthLayout from "./components/layout/AuthLayout";
import Transcripts from "./components/dashboard/Transcripts";
import MediaPlayback from "./components/dashboard/MediaPlayback";
import MediaPlayback2 from "./components/dashboard/MediaPlayback2";
import Insights from "./components/dashboard/Insights";
import UploadCall from "./components/dashboard/UploadCall";
import CallDetail from "./components/dashboard/CallDetail";
import Settings from "./components/dashboard/Settings";
import MeetingDashboard from "./components/dashboard/MeetingDashboard";
import GoogleMeetIntegration from "./components/dashboard/GoogleMeet";
import GoogleCallback from "./pages/GoogleCallback";
import ProtectedRoute from "./components/ProtectedRoute";
import tokenManager from "./utils/tokenManager";
import TeamMemberSignup from "./components/auth/TeamMemberSignup";
import TeamsIntegration from "./components/dashboard/Teams";
import { UserProvider } from "./contexts/UserContext";
import Authorize from "./pages/Authorize";

// Email components
import EmailIntegration from "./components/dashboard/EmailIntegration";
import EmailMessages from "./components/dashboard/EmailMessages";
import EmailDetail from "./components/dashboard/EmailDetail";
import EmailAnalytics from "./components/dashboard/EmailAnalytics";
import EmailLegalHolds from "./components/dashboard/EmailLegalHolds";
import WebexSettings from "./components/dashboard/WebexSettings";
import CallSwitchSettings from "./components/dashboard/CallSwitchSettings";
import CallSwitchTranscripts from "./components/dashboard/CallSwitchTranscripts";
import SalesCallDetail from "./components/dashboard/SalesCallDetail";
import SalesTranscripts from "./components/dashboard/SalesTranscripts";
import RecordingStudio from "./components/dashboard/RecordingStudio";
import WebexUserSettings from "./components/dashboard/WebexUserSettings";
import ProductGuard from "./components/ProductGuard";

function App() {
  return (
    <UserProvider>
      <Router>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/onboarding/" element={<OnboardingSteps />} />
          <Route path="/workspace-ready" element={<WorkspaceReady />} />
          <Route path="/email-verification" element={<EmailVerification />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-success" element={<PasswordResetSuccess />} />
          <Route path="/new-password" element={<NewPassword />} />
          <Route path="/auth/google/callback" element={<GoogleCallback />} />
          <Route path="/invite/:token" element={<TeamMemberSignup />} />
          <Route path="/integrations/authorize" element={<Authorize />} />

          {/* Protected routes */}

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <ProductGuard
                  product="octopush_x"
                  crossAppUrl={process.env.REACT_APP_RECORDING_STUDIO_URL}
                >
                  <Layout />
                </ProductGuard>
              </ProtectedRoute>
            }
          >
            <Route index element={<Navigate to="overview" replace />} />
            <Route path="overview" element={<Dashboard />} />
            <Route path="transcripts" element={<Transcripts />} />
            <Route path="sales-transcripts" element={<SalesTranscripts />} />
            <Route path="media-playback" element={<MediaPlayback />} />
            <Route path="recording-studio" element={<RecordingStudio />} />
            <Route
              path="/media-playback/:meetingId"
              element={<MediaPlayback2 />}
            />
            <Route path="insights" element={<Insights />} />
            <Route path="upload-call" element={<UploadCall />} />
            <Route path="calls/:id" element={<CallDetail />} />
            <Route path="sales-calls/:id" element={<SalesCallDetail />} />
            <Route path="teams" element={<TeamsIntegration />} />
            <Route
              path="support"
              element={<div className="p-6">Support Page</div>}
            />
            <Route path="settings" element={<Settings />} />
            <Route path="webex" element={<WebexSettings />} />
            <Route path="webex-users" element={<WebexUserSettings />} />
            <Route path="meetings" element={<MeetingDashboard />} />
            <Route path="callswitch" element={<CallSwitchSettings />} />
            <Route
              path="callswitch-calls"
              element={<CallSwitchTranscripts />}
            />
            <Route path="/google" element={<GoogleMeetIntegration />} />
            <Route
              path="/google/callback"
              element={<GoogleMeetIntegration />}
            />

            {/* Email routes */}
            <Route path="email" element={<EmailIntegration />} />
            <Route path="email/messages" element={<EmailMessages />} />
            <Route path="email/messages/:id" element={<EmailDetail />} />
            <Route path="email/analytics" element={<EmailAnalytics />} />
            <Route path="email/legal-holds" element={<EmailLegalHolds />} />
          </Route>

          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/overview" replace />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
